type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'OperationIndex'
const nameSource = 'financial/operationIndexes'
const namePageTitle = 'Índices de Operação'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Índices de Operação',
  to: '/financial/operationIndexes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/operationIndexes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/operationIndexes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/operationIndexes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
